/**
 * This file was auto-generated by Fern from our API Definition.
 */
import { toJson } from "../core/json";
export class FlatfileError extends Error {
    constructor({ message, statusCode, body, rawResponse, }) {
        super(buildMessage({ message, statusCode, body }));
        Object.setPrototypeOf(this, FlatfileError.prototype);
        this.statusCode = statusCode;
        this.body = body;
        this.rawResponse = rawResponse;
    }
}
function buildMessage({ message, statusCode, body, }) {
    let lines = [];
    if (message != null) {
        lines.push(message);
    }
    if (statusCode != null) {
        lines.push(`Status code: ${statusCode.toString()}`);
    }
    if (body != null) {
        lines.push(`Body: ${toJson(body, undefined, 2)}`);
    }
    return lines.join("\n");
}
